import React from 'react'
import {
  Card,
  Row,
  Col,
  Statistic,
  Table,
  Button,
  Space,
} from 'antd'
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons'
import { useModulePermission } from '@/hooks/useModulePermission'
import '../Lead/LeadList.css'

const GSTReport: React.FC = () => {
  const { canDownload } = useModulePermission('Reports')
  const gstData = [
    {
      key: '1',
      period: 'June 2024',
      gstr1Filed: 'Yes',
      totalInvoices: 12,
      taxableAmount: 330000,
      gstAmount: 59400,
      gstr3bFiled: 'No',
    },
    {
      key: '2',
      period: 'May 2024',
      gstr1Filed: 'Yes',
      totalInvoices: 10,
      taxableAmount: 305000,
      gstAmount: 54900,
      gstr3bFiled: 'Yes',
    },
  ]

  const columns = [
    { title: 'Period', dataIndex: 'period', key: 'period' },
    { title: 'Total Invoices', dataIndex: 'totalInvoices', key: 'totalInvoices' },
    {
      title: 'Taxable Amount (₹)',
      dataIndex: 'taxableAmount',
      key: 'taxableAmount',
    },
    { title: 'GST Amount (₹)', dataIndex: 'gstAmount', key: 'gstAmount' },
    { title: 'GSTR-1 Filed', dataIndex: 'gstr1Filed', key: 'gstr1Filed' },
    { title: 'GSTR-3B Filed', dataIndex: 'gstr3bFiled', key: 'gstr3bFiled' },
  ]

  return (
    <div className="lead-list-container">
      <div className="list-header">
        <h2>GST Compliance Report</h2>
        <Space>
          {canDownload && <Button icon={<DownloadOutlined />}>Export Excel</Button>}
          <Button icon={<PrinterOutlined />}>Print</Button>
        </Space>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Total GST Collected"
              value={114300}
              prefix="₹"
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="GSTR-1 Filed"
              value={2}
              suffix=" Returns"
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="GSTR-3B Filed"
              value={1}
              suffix=" Return"
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <Card className="kpi-card">
            <Statistic
              title="Total Invoices"
              value={22}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: '16px' }}>
        <h3>GST Compliance Status</h3>
        <Table
          dataSource={gstData}
          columns={columns}
          pagination={{ defaultPageSize: 10, pageSizeOptions: ['10', '25', '50', '100'], showSizeChanger: true }}
          rowKey="key"
        />
      </Card>
    </div>
  )
}

export default GSTReport
